// extracted by mini-css-extract-plugin
module.exports = {"root":"Dot_root__3Vole","active":"Dot_active__2WKZy"};